module.exports = __webpack_public_path__ + "img/funnel-temperatura-2021.f612fd76.svg";